import { connect } from 'react-redux'
import { Route, Routes } from 'react-router-dom'

import { Claim } from './claim/Claim'
import { Confirmation } from './confirmation/Confirmation'
import { Identity } from './identity/Identity'
import { Prefill } from './Prefill'
import { AvailabilityManager } from './shared/AvailabilityManager'
import { FourOhFour } from './shared/FourOhFour'
import { PrivateRoute } from './shared/PrivateRoute'
import type { GlobalState } from './types'
import { Upload } from './upload/Upload'

type RouterProps = {
  valid: boolean
}

const TheRouterComponent = ({ valid }: RouterProps) => {
  return (
    <Routes>
      <Route path={`${window.travURI}prefill/:token`} element={<Prefill />} />
      <Route
        path={`${window.travURI}identity`}
        element={
          <PrivateRoute valid={valid}>
            <Identity />
          </PrivateRoute>
        }
      />
      {/* Optional upload param external needs to be listed first.*/}
      <Route
        path={`${window.travURI}upload/:external`}
        element={
          <PrivateRoute valid={valid}>
            <Upload />
          </PrivateRoute>
        }
      />
      <Route
        path={`${window.travURI}upload`}
        element={
          <PrivateRoute valid={valid}>
            <Upload />
          </PrivateRoute>
        }
      />
      <Route
        path={`${window.travURI}confirmation`}
        element={
          <PrivateRoute valid={valid}>
            <Confirmation />
          </PrivateRoute>
        }
      />
      <Route
        path={`${window.travURI}maintenance`}
        element={<AvailabilityManager />}
      />
      {/* Claim is at the bottom because otherwise all extended paths
        will match window.travURI */}
      <Route path={`${window.travURI}`} element={<Claim />} />
      <Route path='*' element={<FourOhFour />} />
    </Routes>
  )
}

const mapStateToProps = (state: GlobalState) => ({
  valid: state.claim.valid
})

const TheRouter = connect(mapStateToProps)(TheRouterComponent)

export { TheRouter }
